module.exports = __webpack_public_path__ + "static/media/contact_support.0610fe99.svg";